import { render, staticRenderFns } from "./DivUnit.vue?vue&type=template&id=234f0fba&scoped=true&"
import script from "./DivUnit.vue?vue&type=script&lang=js&"
export * from "./DivUnit.vue?vue&type=script&lang=js&"
import style0 from "./DivUnit.vue?vue&type=style&index=0&id=234f0fba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f0fba",
  null
  
)

export default component.exports